/* eslint-disable import/prefer-default-export */
import { UseQueryOptions } from "@tanstack/react-query";
import { getTask } from "api/services/task";
import { useCustomQuery } from "hooks/useCustomQuery";
import { taskQueryKeys } from "./taskQueryKeys";

interface useGetTaskDetailsOptions {
  config?: any;
  options?: UseQueryOptions;
}

export const useGetTaskDetails = (taskId: string, { config, options }: useGetTaskDetailsOptions): any =>
  useCustomQuery({
    queryKey: taskQueryKeys.taskDetails(taskId, config),
    queryFn: () => getTask(taskId, config).then((res) => res.data),
    ...options,
  });
